import React, {useEffect, useState} from 'react'
import {useSelector} from "react-redux";
import ErrorModal from "../../../../../organisms/Modal/ErrorModal/ErrorModal";
import PaymentsBox from "./PaymentsBox";
import {isDefined} from "../../../../../../utils";
import CreatePaymentModal from "./CreatePaymentModal";
import {Grid} from "@material-ui/core";

const PaymentList = (props) => {

    const {
        paymentMapping,
        UpdatePaymentMapping,
        UpdatePaymentStatusMapping,
        PaymentStatusSetDefault,
        PaymentInstallmentUpdate,
        updatePaymentErrorClear,
        successPaymentClear,
        paymentTypeGet,
        createPaymentMapping,
        GetPaymentType,
        paymentTypeList,
        paymentGetListFetching,
        maxCurrencyCount
    } = props;

    const paymentBoxStatusData = useSelector(state => state.paymentReducers?.updatePaymentMappingBoxStatusData?.data);

    const [statusOverrides, setStatusOverrides] = useState({});

    useEffect(() => {
        if (paymentBoxStatusData?.currency_code !== undefined) {
            setStatusOverrides(prev => ({
                ...prev,
                [paymentBoxStatusData.currency_code]: !!paymentBoxStatusData.status
            }));
        }
    }, [paymentBoxStatusData]);

    const paymentPolicyListError = useSelector(props => props.paymentMapping?.errorPaymentTypeList)
    const paymentBoxStatusReducersError = useSelector(props => props.paymentReducers?.errorUpdatePaymentMappingBoxStatusData)

    const currentEnabledCount = isDefined(paymentTypeGet?.currencies)
        ? paymentTypeGet.currencies.filter(c => {
            if (!isDefined(c.fields)) return false;
            if (c.code in statusOverrides) return statusOverrides[c.code];
            return c.status === 1;
        }).length
        : 0;

    const isLimitReached = maxCurrencyCount > 0 && currentEnabledCount >= maxCurrencyCount;

    useEffect( () => {},[paymentPolicyListError]);

    const showMessage = () => {
        if(paymentPolicyListError?.response?.status === 400 || paymentPolicyListError?.response?.status === 500)
        {
            let message = paymentPolicyListError?.response.data.message
            return  <ErrorModal status={true} message={message}/>
        }
    }

    const showBoxStatusErrorMessage = () => {
        const errorStatus = paymentBoxStatusReducersError?.response?.status
        if(errorStatus === 500 || errorStatus === 400 || errorStatus === 401)
        {
            let message = paymentBoxStatusReducersError?.response.data.message
            return  <ErrorModal status={true} message={message}/>
        }
    }

    const getEffectiveStatus = (currency) =>
        currency.code in statusOverrides
            ? (statusOverrides[currency.code] ? 1 : 0)
            : (currency.status ?? 1);

    const priorityCurrencies = ["TRY", "EUR", "USD"];
    const sortedCurrencies = isDefined(paymentTypeGet.currencies)
        ? [...paymentTypeGet.currencies].sort((a, b) => {
            const aIndex = priorityCurrencies.indexOf(a.code);
            const bIndex = priorityCurrencies.indexOf(b.code);
            if (aIndex === -1 && bIndex === -1) return 0;
            if (aIndex === -1) return 1;
            if (bIndex === -1) return -1;
            return aIndex - bIndex;
        })
        : [];

    return(
        <Grid container>
            {
                !paymentGetListFetching &&
                <>
                    {
                        isDefined(paymentTypeGet.currencies) && sortedCurrencies.map( paymentMappingList => (

                            <>
                                {
                                    isDefined(paymentMappingList.fields) ?
                                        <PaymentsBox
                                            paymentMappingListData={paymentMappingList}
                                            paymentMapping={paymentMapping}
                                            UpdatePaymentMapping={UpdatePaymentMapping}
                                            UpdatePaymentStatusMapping={UpdatePaymentStatusMapping}
                                            PaymentStatusSetDefault={PaymentStatusSetDefault}
                                            PaymentInstallmentUpdate={PaymentInstallmentUpdate}
                                            updatePaymentErrorClear={updatePaymentErrorClear}
                                            successPaymentClear={successPaymentClear}
                                            paymentTypeGet={paymentTypeGet}
                                            GetPaymentType={GetPaymentType}
                                            paymentTypeList={paymentTypeList}
                                            isLimitReached={isLimitReached}
                                            isLocked={isLimitReached && !getEffectiveStatus(paymentMappingList)}

                                        />
                                        :
                                        <CreatePaymentModal
                                            paymentMappingList={paymentMappingList}
                                            paymentMapping={paymentMapping}
                                            createPaymentMapping={createPaymentMapping}
                                            updatePaymentErrorClear={updatePaymentErrorClear}
                                            successPaymentClear={successPaymentClear}
                                            paymentTypeGet={paymentTypeGet}
                                            GetPaymentType={GetPaymentType}
                                            isLimitReached={isLimitReached}
                                        />
                                }
                            </>
                        ))

                    }
                </>
            }

            {
                showMessage()
            }
            {
                showBoxStatusErrorMessage()
            }
        </Grid>
    )
}

export default PaymentList;
